var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58,1H6C3.243,1,1,3.243,1,6v40c0,2.757,2.243,5,5,5h15.72l-1.5,6H19c-2.206,0-4,1.794-4,4v1c0,0.553,0.447,1,1,1h32 c0.553,0,1-0.447,1-1v-1c0-2.206-1.794-4-4-4h-1.22l-1.5-6H58c2.757,0,5-2.243,5-5V6C63,3.243,60.757,1,58,1z M47,61H17 c0-1.103,0.897-2,2-2h26C46.103,59,47,59.897,47,61z M41.72,57H22.28l1.5-6H40.22L41.72,57z M61,46c0,1.654-1.346,3-3,3H6 c-1.654,0-3-1.346-3-3V6c0-1.654,1.346-3,3-3h52c1.654,0,3,1.346,3,3V46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,5H6C5.447,5,5,5.448,5,6v36c0,0.553,0.447,1,1,1h52c0.553,0,1-0.447,1-1V6C59,5.448,58.553,5,58,5z M57,41H7V7h50V41z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,35h1.101c0.465,2.279,2.484,4,4.899,4h10c2.414,0,4.434-1.721,4.899-4H34c1.654,0,3-1.346,3-3v-4c0-1.654-1.346-3-3-3 h-1.101c-0.465-2.279-2.484-4-4.899-4v-1c0-1.654-1.346-3-3-3h-1v-2.184c1.161-0.414,2-1.514,2-2.816c0-1.654-1.346-3-3-3 s-3,1.346-3,3c0,1.302,0.839,2.402,2,2.816V17h-1c-1.654,0-3,1.346-3,3v1c-2.414,0-4.434,1.721-4.899,4H12c-1.654,0-3,1.346-3,3v4 C9,33.654,10.346,35,12,35z M35,28v4c0,0.551-0.448,1-1,1h-1v-6h1C34.552,27,35,27.449,35,28z M23,11c0.552,0,1,0.449,1,1 s-0.448,1-1,1s-1-0.449-1-1S22.448,11,23,11z M20,20c0-0.551,0.448-1,1-1h4c0.552,0,1,0.449,1,1v1h-6V20z M15,26 c0-1.654,1.346-3,3-3h10c1.654,0,3,1.346,3,3v8c0,1.654-1.346,3-3,3H18c-1.654,0-3-1.346-3-3V26z M11,28c0-0.551,0.448-1,1-1h1v6 h-1c-0.552,0-1-0.449-1-1V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,31c1.654,0,3-1.346,3-3s-1.346-3-3-3s-3,1.346-3,3S17.346,31,19,31z M19,27c0.552,0,1,0.449,1,1s-0.448,1-1,1 s-1-0.449-1-1S18.448,27,19,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,31c1.654,0,3-1.346,3-3s-1.346-3-3-3s-3,1.346-3,3S25.346,31,27,31z M27,27c0.552,0,1,0.449,1,1s-0.448,1-1,1 s-1-0.449-1-1S26.448,27,27,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,33c0,1.654,1.346,3,3,3s3-1.346,3-3h-2c0,0.552-0.448,1-1,1s-1-0.448-1-1H20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,21h7v2c0,0.404,0.243,0.769,0.617,0.924C45.741,23.975,45.871,24,46,24c0.26,0,0.516-0.102,0.707-0.293L49.414,21H52 c1.654,0,3-1.346,3-3v-6c0-1.654-1.346-3-3-3H38c-1.654,0-3,1.346-3,3v6C35,19.654,36.346,21,38,21z M37,12c0-0.551,0.448-1,1-1h14 c0.552,0,1,0.449,1,1v6c0,0.551-0.448,1-1,1h-3c-0.266,0-0.52,0.105-0.707,0.293L47,20.586V20c0-0.552-0.447-1-1-1h-8 c-0.552,0-1-0.449-1-1V12z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 14,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 14,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,29h-4.586l-2.707-2.707c-0.286-0.286-0.716-0.371-1.09-0.217C43.243,26.231,43,26.596,43,27v2h-1c-1.654,0-3,1.346-3,3 v4c0,1.654,1.346,3,3,3h10c1.654,0,3-1.346,3-3v-4C55,30.346,53.654,29,52,29z M53,36c0,0.552-0.448,1-1,1H42c-0.552,0-1-0.448-1-1 v-4c0-0.551,0.448-1,1-1h2c0.553,0,1-0.448,1-1v-0.586l1.293,1.293C46.48,30.895,46.734,31,47,31h5c0.552,0,1,0.449,1,1V36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 33,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 33,
    width: 2,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.32508a7c1bf875559cc430f1dcd04d9d.svg";
export { ForwardRef as ReactComponent };